import * as z from "zod";

export const getSalesVsRefundsOverTime = {
  name: "getSalesVsRefundsOverTime" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    sales: z.array(z.object({ date: z.string(), value: z.number() })),
    refunds: z.array(z.object({ date: z.string(), value: z.number() })),
  }),
};
